import { render, staticRenderFns } from "./myselfUser.vue?vue&type=template&id=7f4d512a&scoped=true"
import script from "./myselfUser.vue?vue&type=script&lang=js"
export * from "./myselfUser.vue?vue&type=script&lang=js"
import style0 from "./myselfUser.vue?vue&type=style&index=0&id=7f4d512a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4d512a",
  null
  
)

export default component.exports